var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.374 3.688c0-.936.752-1.688 1.688-1.688h7.876c.936 0 1.688.752 1.688 1.688 0 .935-.753 1.688-1.688 1.688h-2.25V8.85a14.516 14.516 0 018.003 3.58l2.053-2.061a1.681 1.681 0 012.385 0c.654.66.66 1.73 0 2.384l-2.18 2.18a14.555 14.555 0 012.679 8.44C34.628 31.452 28.08 38 20 38S5.372 31.46 5.372 23.38c0-7.512 5.654-13.693 12.94-14.53V5.376h-2.25a1.684 1.684 0 01-1.688-1.688zM20 34.63a11.252 11.252 0 100-22.504 11.252 11.252 0 000 22.504zm1.688-17.44v7.313c0 .936-.753 1.688-1.688 1.688a1.684 1.684 0 01-1.688-1.688V17.19c0-.935.753-1.687 1.688-1.687.935 0 1.688.752 1.688 1.688z",
    fill: "#fff"
  })));
}
export default SvgQuickAnalysis;